(function () {
  Flint.file("mframework/views/uploader.js", function (require) {
    Flint.staticStyles("Uploader", {
      "$label": "#_flintapp label.Uploader, #_flintapp .Uploader.label, #_flintapp .ViewUploader.label, #_flintapp .Uploader > .label",
      "$input": "#_flintapp input.Uploader, #_flintapp .Uploader.input, #_flintapp .ViewUploader.input, #_flintapp .Uploader > .input"
    }, {
      "$label": {
        position: 'relative',
        overflow: 'hidden'
      },
      "$input": {
        position: 'absolute',
        cursor: 'pointer',
        borderRadius: 0,

        // Get the button+text UI out of the visible container area because
        // e.g. the button doesn't have the cursor:'pointer' style we want.
        width: 2000,
        left: -500,
        right: 0,
        top: 0,
        bottom: 0,

        background: 'yellow'
      }
    });
    Flint.view("Uploader", function (view, on, $) {
      var context = initContext(view, {
        isMobile: atom()
      });

      var pro = initPro(view, {
        accept: atom(),
        children: atom()
      });

      var dragging = atom(false);view.render(function () {
        return view.el(
          ["label", 1],
          {
            onDragEnter: function () {
              return dragging.set(true);
            },
            onDragLeave: function () {
              return dragging.set(false);
            }
          },
          view.el(
            ["childrenSec", 1],
            null,
            pro.children.get() || "Choose file..."
          ),
          view.el(["input", 1], {
            type: "file",
            capture: "camera",
            accept: pro.accept.get(),
            onChange: view.props.onChange
          })
        );
      });

      $["input"] = function (_, _index) {
        return { opacity: dragging.get() ? 0.3 : 0
        };
      };
    });
  })
})();
//# sourceMappingURL=uploader.js.map
